import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Row, Col, CardBody, Card, Container, Button } from "reactstrap";
const sections = [
  { label: "Agriculture, forestry and fishing", value: "A" },
  { label: "Mining and quarrying", value: "B" },
  { label: "Manufacturing", value: "C" },
  { label: "Electricity, gas, steam and air conditioning supply", value: "D" },
  { label: "Water supply; sewerage, waste management and remediation activities", value: "E" },
  { label: "Construction", value: "F" },
  { label: "Wholesale and retail trade; repair and selling of motor vehicles and motorcycles", value: "G" },
  { label: "Transportation and storage", value: "H" },
  { label: "Accommodation and food service activities", value: "I" },
  { label: "Information and communication", value: "J" },
  { label: "Financial and insurance activities", value: "K" },
  { label: "Real estate activities", value: "L" },
  { label: "Professional, scientific and technical activities", value: "M" },
  { label: "Administrative and support service activities", value: "N" },
  { label: "Public administration and defence; compulsory social security", value: "O" },
  { label: "Education", value: "P" },
  { label: "Human health and social work activities", value: "Q" },
  { label: "Arts, entertainment and recreation", value: "R" },
  { label: "Other service activities", value: "S" },
  { label: "Activities of households as employers; undifferentiated goods- and services-producing activities of households for own use", value: "T" },
  { label: "Activities of extraterritorial organizations and bodies", value: "U" },
];
const Step4 = () => {
  const [selected, setSelected] = useState("");
  return (
    <React.Fragment>
      
      <div className="account-pages my-5 pt-sm-5">
       
          <Row className="justify-content-center">
            <Col md={8} lg={8} xl={12}>
              <Card className="overflow-hidden">
                {/* <div className="bg-primary">
                  <div className="text-primary text-center p-4">
                    <h5 className="text-white font-size-20">About yourself</h5>
                    <p className="text-white-50">Let's get you onboard.</p>
                    <Link to="/index" className="logo logo-admin">
                      <img src={logoSm} height="24" alt="logo" />
                    </Link>
                  </div>
                </div> */}
                <CardBody className="p-4">
                  <div className="p-3">
                    <div className="mb-4 p-3 bg-light">
                      <h5 className="fw-bold">Question Time.</h5>
                      <p>
                        We’re about to ask a series of questions to help us better understand your business. While some questions may not seem directly relevant, rest assured they help us build a complete picture of your business.
                      </p>
                      <p>
                        Completing the questionnaire will take approximately 30 minutes. Alternatively, you can complete it in smaller sections—your progress will be saved, and you can return anytime by logging back into your account.
                      </p>
                    </div>
                    <div className="mb-4 p-3 bg-light">
                      <h5 className="fw-bold">Now, to chat about your business.</h5>
                      <p>
                        We’ve grabbed these details from your accounting software. Just tick the box if everything looks good, or make changes if something’s not quite right.
                      </p>
                    </div>
                    <form className="mt-4" action="#">
                      {/* <div className="mb-3">
                        <label className="form-label" htmlFor="textarea">Tell me about yourself</label>
                        <textarea className="form-control" id="textarea" name="message" rows="4"></textarea>
                      </div> */}
                      {/* <div className="mb-3">
                        <label className="form-label" htmlFor="abn">ABN</label>
                        <input type="text" className="form-control" id="abn" placeholder="Enter ABN" />
                      </div> */}
                      <div className="mb-3">
                        <label className="form-label" htmlFor="industry">Industry</label>
                        <br />
                        <select id="industry"
                          className="w-full p-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
                          value={selected}
                          onChange={(e) => setSelected(e.target.value)}
                        >
                          <option value="">-- Select Industry --</option>
                          {sections.map((section) => (
                            <option key={section.value} value={section.value}>
                              {section.label}
                            </option>
                          ))}
                        </select>
                      </div>
                      {/* <div className="mb-3">
                        <label className="form-label" htmlFor="address">Address</label>
                        <input type="text" className="form-control" id="address" placeholder="Enter your address" />
                      </div> */}
                      <div className="mt-6">
                        <label className="block mb-2 font-bold text-gray-700">What does your business sell to?</label>
                        <div className="d-flex gap-3">
                          {"Other Businesses,Individuals,A bit of both".split(",").map((option, index) => (
                            <div
                              key={index}
                              className={`box ${selected === option ? "selected bg-[#A3E566] text-blue text-center" : "bg-gray-100 text-black text-center"}`}
                              onClick={() => setSelected(option)}
                            >
                              {option}
                            </div>
                          ))}
                        </div>
                      </div>
                      {/* <div className="mb-3 row">
                        <div className="col-12 text-end">
                          <button className="btn btn-primary w-md waves-effect waves-light" type="submit">Submit</button>
                        </div>
                      </div> */}
                    </form>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
       
      </div>
    </React.Fragment>
  );
};

export default Step4;
